
export function Divider(props: { width: number }) {
    return (
        <div className="divider" style={{ width: `${props.width}%` }}>
            <div className="divider-line"></div>
        </div>
    );
}
